export default __webpack_public_path__ + "static/media/unicef-logo.6a7596a6.png";